<template>
  <main class="l-main p-register">
    <div class="l-block">
      <TitleRegister>
        <Progress :items="progress" />
      </TitleRegister>
      <div class="l-block__content">
        <div class="hTitle">
          <h1>
            登録済みのメールアドレスに、パスワード再設定メールを送信します。
          </h1>
        </div>
        <div class="description">
          <p>
            メールが届かない場合は、カスタマーサポート(<a
              :href="'mailto:' + $constants.customerSupportEmail"
              >{{ $constants.customerSupportEmail }}</a
            >)までご連絡いただきますようお願いいたします。
          </p>
        </div>
        <div class="flex">
          <div class="title">
            <p>
              メールアドレス
              <span class="c-required">必須</span>
            </p>
          </div>
          <div class="form c-alertPos">
            <Input
              name="email"
              v-model="params.email"
              placeholder="例：sample@example.com"
              :class="{ alert: isEdited.email && error.email }"
              :disabled="isEdit"
            />
            <Alert v-if="isEdited.email && error.email">
              {{ error.email }}
            </Alert>
          </div>
        </div>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              variant="main"
              size="w260"
              fsize="f16"
              icon="arrow_r"
              :disabled="isError || isProcessing"
              :class="{ 'is-loading': isProcessing }"
              @click="submit"
            >
              送信する
            </Button>
          </div>
        </div>
        <div v-if="errorAll">
          <div class="errorAll">
            <Alert>
              {{ errorAll }}
            </Alert>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Progress from '@/components/Progress';
import TitleRegister from '@/components/TitleRegister';
import utils from '@/utils';
import Validation from '@/validation';

export default {
  props: {
    email: {
      type: String,
      required: false
    }
  },
  components: {
    Alert,
    Button,
    Input,
    Progress,
    TitleRegister
  },

  data() {
    return {
      error: {
        email: ''
      },
      errorAll: '',
      params: {
        email: this.email ? this.email : ''
      },
      progress: [
        {
          current: true,
          label: 'アドレス入力'
        },
        {
          label: '送信完了'
        }
      ],
      isEdited: {
        email: false
      },
      isError: false,
      isProcessing: false
    };
  },

  computed: {
    isEdit() {
      return this.email ? true : false;
    }
  },

  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    'params.email': {
      handler(value, oldValue) {
        this.error.email = new Validation()
          .input()
          .email()
          .test(this.params.email.trim());
        if (typeof oldValue !== 'undefined') {
          this.isEdited.email = true;
        }
      },
      immediate: true
    }
  },

  methods: {
    checkError() {
      this.isError = utils.checkError(this.error);
    },

    submit() {
      if (this.isError || this.isProcessing) {
        return;
      }
      this.isProcessing = true;

      this.auth
        .changePassword(this.params)
        .then(response => {
          this.$router.push({ name: 'resetPasswordConfirm' });
        })
        .catch(error => {
          this.isProcessing = false;
          this.errorAll = ERROR_MESSAGE.auth0[error.code]
            ? ERROR_MESSAGE.auth0[error.code]
            : ERROR_MESSAGE.other;
        });
    }
  }
};
</script>
